import { DailyReportRequestModel } from '../api/models/DailyReportPageRequestModel';
import { DailyReportFormModel } from '../models';

export const dataFormToRequest = (data: DailyReportFormModel): DailyReportRequestModel => ({
  date: data.day,
  comment: data.comment,
  file_type: data.file_type,
});
